import { Link } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";

import {
  useDesign,
} from "../../shared/design/DesignProvider";

import { AppearancePicker } from "./AppearancePicker";

import "./ProfilePage.css";

function planLabel(plan: string): string {
  if (plan === "PREMIUM_PLUS") {
    return "SARADIUM Premium Plus";
  }

  if (plan === "PREMIUM") {
    return "SARADIUM Premium";
  }

  return "SARADIUM Free";
}

function styleLabel(style: string): string {
  if (style === "LIQUID_GLASS") {
    return "Liquid Glass";
  }

  if (style === "SOFT_NEUMORPHISM") {
    return "Soft Neumorphism";
  }

  return "Spatial Flow";
}

export function ProfilePage() {
  const { user } = useAuth();

  const {
    plan,
    style,
    loading,
    developer,
  } = useDesign();

  const name =
    user?.name?.trim() || "SARADIUM user";

  const initial = name.charAt(0).toUpperCase();

  return (
    <main className="profile-page">
      <header className="profile-page__header">
        <span>SARADIUM IDENTITY</span>

        <h1>Profile</h1>

        <p>
          Your account, membership and complete
          SARADIUM appearance settings.
        </p>
      </header>

      <section className="profile-page__identity">
        <div
          className="profile-page__avatar"
          aria-hidden="true"
        >
          {initial}
        </div>

        <div className="profile-page__identity-copy">
          <h2>{name}</h2>

          <p>{user?.email || "No email available"}</p>

          <div className="profile-page__pills">
            <span>
              {user?.emailVerification
                ? "Email verified"
                : "Verification pending"}
            </span>

            <span>
              {loading
                ? "Checking membership…"
                : developer
                  ? "Developer access"
                  : planLabel(plan)}
            </span>
          </div>
        </div>

        <Link
          className="profile-page__account-link"
          to="/account"
        >
          Account
        </Link>
      </section>

      <section className="profile-page__summary-grid">
        <article>
          <span>YOUR PLAN</span>

          <strong>
            {loading
              ? "Loading…"
              : developer
                ? "Developer access"
                : planLabel(plan)}
          </strong>

          <p>
            Your membership unlocks the interface
            designs available to your account.
          </p>

          <Link to="/app/subscription">
            Manage membership
          </Link>
        </article>

        <article>
          <span>ACTIVE DESIGN</span>

          <strong>{styleLabel(style)}</strong>

          <p>
            Every card, calendar, input and navigation
            item follows this one selected design.
          </p>
        </article>

        <article>
          <span>ACCOUNT & PRIVACY</span>

          <strong>Security settings</strong>

          <p>
            Manage password, sign-in sessions and
            account details through Appwrite.
          </p>

          <Link to="/account">
            Open account settings
          </Link>
        </article>
      </section>

      <AppearancePicker />
    </main>
  );
}